var app = angular.module('AppCtrl.ContactDetails', [
    'jv.Common.Modal',
    'ContactDetailsModule',
    'ContactDetailsAddReqsModule',
    'shareContactSeekConsentModule',
    'jv.Common.Loading',
    'jv.Common.EmployeeSelect',
    'AppCtrl.ContactDetails.service',
    'JVNG-socialWidgets',
    'JV.Core.Directives',
    'jv.Common.DataConsent',
    'jv.Common.Directives.Datepicker',
    'ui.directives',
    'jv.Common.Filters',
    'jv.campaigns.email-campaign-modal.directive',
    'ngRoute',
    'jv.Common.AjaxSelect',
    'jv.common.numberFormatter.directive',
    'jv.common.currency.directive'
]);
app.config(['$provide', function ($provide) {
        $provide.decorator('url', function () {
            return '../../admin/action/user/search';
        });
    }])
    .factory('isIE', ['$window', function ($window) {
        if ($window.addEventListener) {
            return false;
        }
        return true;
    }])
    .factory('addEventListener', ['isIE', function (isIE) {
        var _toAttach = angular.noop,
            _prefix = angular.identity;
        if (!isIE) {
            _toAttach = 'addEventListener';
            _prefix = angular.identity;
        } else {
            _toAttach = 'attachEvent';
            _prefix = function (val) {
                return 'on' + val;
            };
        }

        var _attach = function (val, cb, capture) {
            this[_toAttach](_prefix(val), cb, capture || false);
        };

        return function (el) {
            return angular.bind(el, _attach);
        };
    }])
    /// TODO (MikeMac): Refactor this to DRY.
    .factory('removeEventListener', ['isIE', function (isIE) {
        var _toAttach = angular.noop,
            _prefix = angular.identity;
        if (!isIE) {
            _toAttach = 'removeEventListener';
            _prefix = angular.identity;
        } else {
            _toAttach = 'detachEvent';
            _prefix = function (val) {
                return 'on' + val;
            };
        }

        var _attach = function (val, cb, capture) {
            this[_toAttach](_prefix(val), cb, capture || false);
        };

        return function (el) {
            return angular.bind(el, _attach);
        };
    }])
    .factory('bindAndUnbindClickToDocument', ['$document', 'addEventListener', 'removeEventListener', function ($document, addEvent, removeEvent) {
        return function bindAndUnbindClickToDocument(el, action) {
            var _doc = $document[0];
            var _outsideHandler = function (ev) {
                action();
                removeEvent(_doc)('click', _outsideHandler, true);
            };
            addEvent(_doc)('click', _outsideHandler, true);
        };
    }])
    .factory('stopPropagation', ['isIE', function (isIE) {
        if (isIE) {
            return function (event) {
                event.cancelBubble = true;
            };
        } else {
            return function (event) {
                event.stopPropagation();
                event.stopImmediatePropagation();
            };
        }
    }])
    .factory('addClick', ['bindAndUnbindClickToDocument', 'addEventListener', 'stopPropagation', function (docMagic, addEvent, stopPropagation) {
        return function addClick(el, activate, deactivate) {
            addEvent(el[0])('click', function (ev) {
                docMagic(el, deactivate);
                activate();
                // stopPropagation(ev);
            }, true);
        };
    }])
    .factory('addMouseover', function () {
        return function addMouseover(el, activate, deactivate) {
            el.bind('mouseover', function () {
                activate();
            });
            el.bind('mouseout', function () {
                deactivate();
            });
        };
    })
    .directive('tooltip', ['$compile', 'addClick', 'addMouseover', 'bindAndUnbindClickToDocument', function ($compile, addClick, addMouseover, docMagic) {
        return {
            replace: true,
            scope: true,
            compile: function (tEl, tAttr) {
                var _trigger = tEl.find('[tooltip-trigger]'),
                    trigger = _trigger.html(),
                    _title = tEl.find('[tooltip-title]'),
                    _title_exists = (_title.length > 0),
                    title = _title.html(),
                    _body = tEl.find('[tooltip-body]'),
                    body = _body.html();
                _trigger.remove();
                _title.remove();
                _body.remove();
                return {
                    pre: function (scope, el, attr) {
                        function tooltipAppear() {
                            scope.__showTooltip__ = true;
                        }

                        function tooltipDisappear() {
                            scope.__showTooltip__ = false;
                        }

                        function tooltipAppearWithApply() {
                            scope.$apply(tooltipAppear);
                        }

                        function tooltipDisappearWithApply() {
                            scope.$apply(tooltipDisappear);
                        }

                        var triggerHtml = angular.element(trigger),
                            tooltip = angular.element("<div class=\"tooltipWindow\" ng-show=\"__showTooltip__\"" + (attr.ngAnimate ? " ng-animate=\"" + attr.ngAnimate + "\"" : "") + "></div>"),
                            tooltipContainer = angular.element("<div class=\"tooltipContainer\"></div>"),
                            titleEl = angular.element("<div class=\"title\"></div>").text(title),
                            bodyEl = angular.element("<div class=\"body\"></div>").text(body),
                            setEvents = ((angular.isDefined(attr.$attr.showonhover) && attr.$attr.showonhover !== 'false') ? addMouseover : addClick);


                        if (angular.isDefined(attr.show)) {
                            scope.$watch(attr.show, function (newVal) {
                                if (newVal) {
                                    docMagic(el, function () {
                                        scope.$parent[attr.show] = false;
                                        tooltipDisappearWithApply();
                                    });
                                    tooltipAppear();
                                }
                            });
                        }

                        scope.__showTooltip__ = false;
                        el.append($compile(triggerHtml)(scope));
                        if (_title_exists) {
                            tooltipContainer.append(titleEl);
                        }
                        tooltipContainer.append(bodyEl);
                        tooltip.append(tooltipContainer);

                        el.append($compile(tooltip)(scope));
                        el.removeClass('tooltip');

                        setEvents(el, tooltipAppearWithApply, tooltipDisappearWithApply);
                    },
                    post: angular.noop
                };
            }
        };
    }]);

app.value('modalTemplateUrl', '../htm/common/modal.html');